import { makeStyles, tokens } from '@fluentui/react-components';
export var useM365LogoStyles = makeStyles({
    container: {
        display: 'flex',
        justifyContent: 'center',
    },
    content: {
        position: 'absolute',
        paddingTop: tokens.spacingVerticalMNudge,
        top: tokens.spacingVerticalXS,
        width: '28px',
        height: '28px',
        alignItems: 'center',
        flexShrink: 0,
    },
});
//# sourceMappingURL=M365Logo.styles.js.map